import { BrowserRouter, Navigate, Route, Routes } from 'react-router'
import { CheckInModal } from '../components/check-in-modal'

export function Router() {
  return (
    <div className="w-screen h-screen bg-transparent font-[Nunito]">
      <BrowserRouter>
        <Routes>
          {/* ${webview}/check-in?liveId=...&liveUserId=...&myUserId=...&token=... */}
          <Route path="/check-in" element={<CheckInModal />} />
          <Route path="/" element={<Navigate to="/check-in" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}
